import type { StoryElement } from '../types';

export function hasTopicContext(story: Pick<StoryElement, 'topic_context'>): boolean {
  return Boolean(story.topic_context && story.topic_context.length > 0);
}

